<template>
  <transition-group name="transition_dialog">
    <DialogOverlay
      v-for="(dd, idx) in dialogs"
      :key="`${dd.dialog}_${idx}`"
      :dialog="dd"
      :data-tst="`dialog_${dd.dialog}`"
      class="dialog_container"
      v-bind="dd.bindings"
      @close="close(dd.str)"
    >
      <template #default>
        <component
          :is="dd.dialog"
          :ref="dd.dialog"
          :dialog="dd"
          @click.stop
        />
      </template>
    </DialogOverlay>
  </transition-group>
</template>

<script>
import { nextTick } from 'vue'
import { gtm_sub_upgrade_dialog_events } from '@/helpers/gtm'
import DialogOverlay from '@/components/Dialogs/DialogOverlay'

import UserSettingsDialog from '@/components/Dialogs/UserSettingsDialog/UserSettingsDialog'
import RoadmapDialog from '@/components/Dialogs/RoadmapDialog/RoadmapDialog'
import CardsDialog from '@/components/Dialogs/CardsDialog/CardsDialog'
import PreflopShortcutDialog from '@/components/Dialogs/PreflopShortcutDialog/PreflopShortcutDialog'
import SaveFilterDialog from '@/components/Dialogs/TableFilterDialog/SaveFilterDialog'
import UpdatePaymentPlanDialog from '@/components/Dialogs/UpdatePaymentPlanDialog/UpdatePaymentPlanDialog'
import CancelPaymentPlanDialog from '@/components/Dialogs/CancelPaymentPlanDialog/CancelPaymentPlanDialog'
import ChartDialog from '@/components/Dialogs/ChartDialogs/ChartDialog'
import ChartEqDialog from '@/components/Dialogs/ChartDialogs/ChartEqDialog'
import HowDidYouDialog from '@/components/Dialogs/HowDidYouDialog/HowDidYouDialog'
import TournamentPhaseDialog from '@/components/Dialogs/TipsDialogs/TournamentPhaseDialog'
import StudyCompareRangeDialog from '@/components/Dialogs/StudyCompareRangeDialog/StudyCompareRangeDialog'
import StudyCompareRangeBuilderDialog from '@/components/Dialogs/StudyCompareRangeDialog/StudyCompareRangeBuilderDialog'
import StudyFilterHelpDialog from '@/components/Dialogs/TipsDialogs/StudyFilterHelpDialog'
import StudyEqBucketsHelpDialog from '@/components/Dialogs/TipsDialogs/StudyEqBucketsHelpDialog'
import StudyGraphSwitcherHelpDialog from '@/components/Dialogs/TipsDialogs/StudyGraphSwitcherHelpDialog'
import StudyStrategyHelpDialog from '@/components/Dialogs/TipsDialogs/StudyStrategyHelpDialog'
import RangeBuilderHelpDialog from '@/components/Dialogs/TipsDialogs/RangeBuilderHelpDialog'
import EvConverterHelpDialog from '@/components/Dialogs/TipsDialogs/EvConverterHelpDialog'
import RangeLengthHelpDialog from '@/components/Dialogs/TipsDialogs/RangeLengthHelpDialog'
import SolfigrNodeCompareDialog from '@/components/Dialogs/Solfigr/SolfigrNodeCompareDialog'
import GemsDialog from '@/components/Dialogs/GemsDialog/GemsDialog'

import StudyMobileGraphDialog from '@/components/Dialogs/StudyMobileGraphDialog/StudyMobileGraphDialog'
import ToursDialog from '@/components/Dialogs/TipsDialogs/ToursDialog'
import RlsDialog from '@/components/Dialogs/TipsDialogs/RlsDialog'

import TrainerAdvancedFilterDialog from '@/components/Dialogs/TrainerAdvancedFilterDialog/TrainerAdvancedFilterDialog'
import PracticeFilterDialog from '@/components/Dialogs/PracticeFilterDialog/PracticeFilterDialog'
import SavedSpotsDialog from '@/components/Dialogs/SavedSpotsDialog/SavedSpotsDialog'
import ImportDrillDialog from '@/components/Dialogs/ImportDialogs/ImportDrillDialog'
import SaveDrillDialog from '@/components/Dialogs/DrillsDialogs/SaveDrillDialog'
import ImportColorPaletteDialog from '@/components/Dialogs/DrillsDialogs/ImportColorPaletteDialog'
import StudyReportsViewDialog from '@/components/Dialogs/StudyReportsViewDialog/StudyReportsViewDialog'
import StudyStrategyViewDialog from '@/components/Dialogs/StudyStrategyViewDialog/StudyStrategyViewDialog'
import TrainerRestoreHandDialog from '@/components/Dialogs/TrainerRestoreHandDialog/TrainerRestoreHandDialog'
import SolutionsDialog from '@/components/Dialogs/SolutionsDialog/SolutionsDialog'
// import SavedFiltersDialog from '@/components/Dialogs/SavedFiltersDialog/SavedFiltersDialog'
import PayoutsDialog from '@/components/Dialogs/PayoutsDialog/PayoutsDialog'
import BubbleFactorsDialog from '@/components/Dialogs/BubbleFactorsDialog/BubbleFactorsDialog'
import BlockersTipsDialog from '@/components/Dialogs/TipsDialogs/BlockersTipsDialog'
import DashboardSettingsDialog from '@/components/Dialogs/DashboardSettingsDialog/DashboardSettingsDialog'
import EvCompareDialog from '@/components/Dialogs/EvCompareDialog/EvCompareDialog'
import YtDialog from '@/components/Dialogs/YtDialog/YtDialog'
import TableColumnsSettingsDialog from '@/components/Dialogs/TableColumnsSettingsDialog/TableColumnsSettingsDialog'

import TritonCardsConfirmDialog from '@/components/Dialogs/TritonConfirmDialog/TritonCardsConfirmDialog'

import SolfigrShortcutDialog from '@/components/Dialogs/Solfigr/SolfigrShortcutDialog'
import SolfigrPlayersRangesDialog from '@/components/Dialogs/Solfigr/SolfigrPlayersRangesDialog'
import SolfigrCreateCustomSolutionDialog from '@/components/Dialogs/Solfigr/SolfigrCreateCustomSolutionDialog'
import SolfigrSaveTreeDialog from '@/components/Dialogs/Solfigr/SolfigrSaveTreeDialog'
import SolfigrNodeEditDialog from '@/components/Dialogs/Solfigr/SolfigrNodeEditDialog'

import SolfigrSavedTreesDialog from '@/components/Dialogs/Solfigr/SolfigrSavedTreesDialog'
import SolfigrSaveRangeDialog from '@/components/Dialogs/Solfigr/SolfigrSaveRangeDialog'
import StudyBetSizesHelpDialog from '@/components/Dialogs/TipsDialogs/StudyBetSizesHelpDialog'
import SolfigrNodeLockDialog from '@/components/Dialogs/Solfigr/SolfigrNodeLockDialog'
import StudyBetTypesHelpDialog from '@/components/Dialogs/TipsDialogs/StudyBetTypesHelpDialog'
import ImportSolfigrRangeDialog from '@/components/Dialogs/Solfigr/ImportSolfigrRangeDialog'
import ImportSolfigrTreeDialog from '@/components/Dialogs/ImportDialogs/ImportSolfigrTreeDialog'

import PromptDialog from '@/components/Dialogs/PromptDialog/PromptDialog'
import PromptNodelockDialog from '@/components/Dialogs/PromptDialog/PromptNodelockDialog'
import SolfigrRakeDialog from '@/components/Dialogs/Solfigr/SolfigrRakeDialog'
import SolfigrIcmStructuresDialog from '@/components/Dialogs/Solfigr/SolfigrIcmStructuresDialog'
import SolfigrIcmStructuresSearchDialog from '@/components/Dialogs/Solfigr/SolfigrIcmStructuresSearchDialog'
import SolfigrIcmStructuresSaveDialog from '@/components/Dialogs/Solfigr/SolfigrIcmStructuresSaveDialog'
import { SNK } from '@/helpers/helpers'

import GenerateCustomReportsDialog from '@/components/Dialogs/GenerateCustomReportsDialog/GenerateCustomReportsDialog.vue'

export default {
  name: 'AppDialogs',
  components: {
    DialogOverlay,
    'triton-confirm-dialog': TritonCardsConfirmDialog,
    'settings-dialog': UserSettingsDialog,
    'roadmap-dialog': RoadmapDialog,
    'cards-dialog': CardsDialog,
    'preflop-shortcut-dialog': PreflopShortcutDialog,
    'practice-filter-dialog': PracticeFilterDialog,
    'update-payment-plan-dialog': UpdatePaymentPlanDialog,
    'cancel-payment-plan-dialog': CancelPaymentPlanDialog,
    'yt-dialog': YtDialog,
    'chart-dialog': ChartDialog,
    'chart-eq-dialog': ChartEqDialog,
    'payouts-dialog': PayoutsDialog,
    'bubble-factors-dialog': BubbleFactorsDialog,
    'how-did-you-dialog': HowDidYouDialog,
    'solutions-dialog': SolutionsDialog,
    'ev-compare-dialog': EvCompareDialog,
    'study-compare-range-dialog': StudyCompareRangeDialog,
    'study-compare-rangebuilder-dialog': StudyCompareRangeBuilderDialog,
    'study-strategy-help-dialog': StudyStrategyHelpDialog,
    'range-builder-help-dialog': RangeBuilderHelpDialog,
    'ev-converter-help-dialog': EvConverterHelpDialog,
    'range-length-switcher-help-dialog': RangeLengthHelpDialog,
    'study-filter-help-dialog': StudyFilterHelpDialog,
    'study-eq-buckets-help-dialog': StudyEqBucketsHelpDialog,
    'study-graph-switcher-help-dialog': StudyGraphSwitcherHelpDialog,
    'study-betsizes-help-dialog': StudyBetSizesHelpDialog,
    'study-bettypes-help-dialog': StudyBetTypesHelpDialog,
    'study-strategy-view-dialog': StudyStrategyViewDialog,
    'study-reports-view-dialog': StudyReportsViewDialog,
    'study-mobile-graph-dialog': StudyMobileGraphDialog,
    'trainer-advanced-filter-dialog': TrainerAdvancedFilterDialog,
    'tournament-phase-dialog': TournamentPhaseDialog,
    'save-filter-dialog': SaveFilterDialog,
    'tours-dialog': ToursDialog,
    'saved-spots-dialog': SavedSpotsDialog,
    'blockers-tips-dialog': BlockersTipsDialog,
    'dashboard-settings-dialog': DashboardSettingsDialog,
    'save-drill-dialog': SaveDrillDialog,
    'trainer-restore-hand-dialog': TrainerRestoreHandDialog,
    'table-columns-settings-dialog': TableColumnsSettingsDialog,
    'rls-dialog': RlsDialog,

    // TODO unify import dialogs under one
    'import-drill-dialog': ImportDrillDialog,
    'import-color-palette-dialog': ImportColorPaletteDialog,
    'import-solfigr-tree-dialog': ImportSolfigrTreeDialog,
    'import-solfigr-ranges-dialog': ImportSolfigrRangeDialog,

    'solfigr-shortcuts-dialog': SolfigrShortcutDialog,
    'solfigr-rake-dialog': SolfigrRakeDialog,
    'solfigr-icm-structures-dialog': SolfigrIcmStructuresDialog,
    'solfigr-icm-structures-search-dialog': SolfigrIcmStructuresSearchDialog,
    'solfigr-icm-structures-save-dialog': SolfigrIcmStructuresSaveDialog,
    'solfigr-players-ranges-dialog': SolfigrPlayersRangesDialog,
    'solfigr-create-custom-solution-dialog': SolfigrCreateCustomSolutionDialog,
    'solfigr-save-tree-dialog': SolfigrSaveTreeDialog,
    'solfigr-save-range-dialog': SolfigrSaveRangeDialog,
    'solfigr-saved-trees-dialog': SolfigrSavedTreesDialog,
    'solfigr-nodeedit-dialog': SolfigrNodeEditDialog,
    'solfigr-nodelock-dialog': SolfigrNodeLockDialog,
    'solfigr-nodecompare-dialog': SolfigrNodeCompareDialog,
    'prompt-dialog': PromptDialog,
    'prompt-nodelock-dialog': PromptNodelockDialog,
    'gems-dialog': GemsDialog,

    'generate-custom-reports-dialog': GenerateCustomReportsDialog,
  },
  data() {
    return {
      dialogs: [],
    }
  },
  created() {
    // to setup dialogs from url alone
    if (this.$route.query.dialogs) {
      // dialogs are reseted on app inititalization exept for some cases
      // (therefore some dialogs can be opened from url alone)
      // probably best to put this to app init - but works for now
      this.setDialogs(this.$route.query.dialogs)
    }
  },
  methods: {
    setDialogs(routeQueryDialogs) {
      let dialogs = []

      if (routeQueryDialogs) {
        const res = routeQueryDialogs.split(',').filter(i => i)

        const animations = {
          'study-compare-range-dialog': 'fadeBottom',
          'study-compare-rangebuilder-dialog': 'fadeBottom',
          'solfigr-nodecompare-dialog': 'fadeBottom',
        }
        const closeStyles = {
          'solutions-dialog': this.mobile ? 'inset: -2.125rem 0.5rem auto auto;' : '',
          'solfigr-players-ranges-dialog': this.mobile ? 'inset: -2.125rem 0.5rem auto auto;' : '',
          'study-compare-range-dialog': 'inset: -2.5rem 0.5rem auto auto;',
          'study-compare-rangebuilder-dialog': 'inset: -2.5rem 0.5rem auto auto;',
          'solfigr-nodecompare-dialog': 'inset: -2.5rem 0.5rem auto auto;',
          'solfigr-create-custom-solution-dialog': this.mobile
            ? 'inset: 0.25rem 0.5rem auto auto;'
            : '',
          'gems-dialog': 'display: none !important;',
        }

        const propsDict = {
          'payouts-dialog': { 'data-gwmenu': 'noclose' },
          'study-betsizes-help-dialog': { 'data-gwmenu': 'noclose' },
          'tournament-phase-dialog': { 'data-gwmenu': 'noclose' },
        }

        dialogs = res.map(str => {
          const propArr = str.split('_').slice(1)

          const props = {}
          propArr.forEach(prop => {
            const keyvalue = prop.split('-')
            props[keyvalue[0]] = keyvalue[1] || true
          })

          const dialog = str.split('_')[0]
          const bindings = propsDict[dialog] || {}

          return {
            str,
            dialog,
            bindings,
            animationType: animations[dialog] || 'scale',
            closeStyle: this.mobile
              ? closeStyles[dialog] || 'inset: 0.5rem 0.5rem auto auto'
              : closeStyles[dialog] || '',
            ...props,
          }
        })
      }

      this.dialogs = dialogs
    },
    handleQueryDialogs() {
      const urlDialogs = this.$route.query.dialogs || ''
      this.setDialogs(urlDialogs)
      this.rmDialogsByRouteQuery(urlDialogs)
    },
    rmDialogsByRouteQuery(urlDialogs) {
      nextTick(() => {
        if (!urlDialogs && !this.dialogs.length) return

        const dialogs = urlDialogs.split(',')
        const removed = this.dialogs.filter(d => !dialogs.some(dd => dd.includes(d.dialog)))

        if (removed.length) {
          this.$store.dispatch('router_rm_dialogs', {
            dialogs: removed.map(d => d.dialog),
          })
        }
      })
    },
    closeTopDialog() {
      const dialog = this.dialogs[this.dialogs.length - 1]
      if (dialog) {
        this.close(dialog.dialog)
      }
    },
    passApplyToTopDialog() {
      const dialog = this.dialogs[this.dialogs.length - 1]
      if (dialog) {
        const component = this.$refs[dialog.dialog]?.[0]
        if (component) {
          if (component.apply) {
            component.apply()
          }
        }
      }
    },
    passKeyToTopDialog(key) {
      const dialog = this.dialogs[this.dialogs.length - 1]
      if (dialog) {
        const component = this.$refs[dialog.dialog]?.[0]
        if (component) {
          if (component.handleKeyPress) {
            component.handleKeyPress(key)
          }
        }
      }
    },
    close(dialog) {
      if (dialog === 'update-payment-plan-dialog') {
        gtm_sub_upgrade_dialog_events({
          subpage: this.$store.state.router.from_path_name || this.$route.name,
          action: 'close',
        })
      }
      this.$store.dispatch('router_rm_dialog', dialog)
    },
  },
  computed: {
    mobile() {
      return this.$store.getters.globals_mobile
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
    hotkeyPressed() {
      return this.$store.getters.hotkey_pressed
    },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
  },
  watch: {
    hotkeyPressed(key) {
      if (!key) return
      if (key === 'escape') {
        if (this.dialogs.length) {
          this.closeTopDialog()
        }
      } else if (key === 'enter') {
        if (this.dialogs.length) {
          this.$store.dispatch('hotkeys_reset')
          this.passApplyToTopDialog()
        }
      }
    },
    hotkeysPressed(keys) {
      if (!keys) return
      this.passKeyToTopDialog(keys)
    },
    '$route.query.dialogs': {
      immediate: false,
      handler: 'handleQueryDialogs',
    },
  },
}
</script>

<style lang="scss">
.dialog_container {
  position: fixed;
  top: 0;
  left: 0;
  height: var(--vh-100);
  width: 100vw;
  display: flex;
  z-index: var(--z-index-dialog);

  .dialog_overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: var(--vh-100);
    width: 100vw;
    background: rgba(0, 0, 0, 0.8);
  }
}

.transition_dialog-enter-active,
.transition_dialog-leave-active {
  --transition-duration: 0.33s;
  --transition-duration-overlay: 0.22s;
  // --transition-duration: 10s;
  transition: var(--transition-duration);
}

.dialog_content {
  margin: auto;
  display: flex;
  position: relative;
  &_close {
    position: absolute !important;
    inset: 0 -2.25rem auto auto;
    font-size: 1.5rem;
    padding: 0.25rem;
    z-index: 8;
  }
  &_fadeBottom {
    margin: auto auto 0 auto;
  }
}

.transition_dialog-leave-to {
  opacity: 0;
}

.transition_dialog-enter-active {
  .dialog_overlay {
    animation: showOverlayDialog var(--transition-duration-overlay) !important;
  }
  .dialog_content {
    &_scale {
      animation: scaleInDialog var(--transition-duration);
    }
    &_fadeBottom {
      animation: fadeBottomInDialog var(--transition-duration);
    }
  }
}

.transition_dialog-leave-active {
  .dialog_content {
    &_scale {
      animation: scaleOutDialog var(--transition-duration);
    }
    &_fadeBottom {
      animation: fadeBottomOutDialog var(--transition-duration);
    }
  }
}

@keyframes showOverlayDialog {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeBottomInDialog {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeBottomOutDialog {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes scaleInDialog {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes scaleOutDialog {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes slideInDialog {
  0% {
    bottom: -100%;
  }
  100% {
    bottom: 0;
  }
}

@keyframes slideOutDialog {
  0% {
    bottom: 0;
  }
  100% {
    bottom: -100%;
  }
}

@media (max-width: 1023px) {
  .dialog_content {
    margin: auto auto 0 auto !important;
    &_close {
      padding: 0.5rem;
      background: rgba(255, 255, 255, 0.05);
    }
  }
  .transition_dialog-enter-active {
    .dialog_content {
      animation: slideInDialog var(--transition-duration) !important;
    }
  }
  .transition_dialog-leave-active {
    .dialog_content {
      animation: slideOutDialog var(--transition-duration) !important;
    }
  }
}
</style>
